import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { Settings2 } from 'lucide-react';
import Sidebar from '../Sidebar';
import { useAuth } from '../../auth';
import { AccountNavigation } from './AccountNavigation';
import { AccountIdentityHeader } from './AccountIdentityHeader';
import './accountLayout.css';

export const AccountLayout = () => {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const reducedMotion = useReducedMotion();
  const path = pathname.replace(/\/$/, '');
  if (!loading && !user) return <Navigate to="/" replace />;
  return <div className="account-shell" data-testid="account-shell"><Sidebar />
    <div className="content-shift pt-16"><main className="account-shell-main" data-testid="account-shell-main">
      <header className="account-shell-heading" data-testid="account-shell-heading"><h1 data-testid="settings-title"><Settings2 size={26} aria-hidden="true" data-testid="account-title-icon" /><span>Settings</span></h1></header>
      <div className="account-shell-workspace" data-testid="account-shell-workspace"><AccountNavigation />
        <div className="account-shell-content" data-testid="account-shell-content">
          {!loading && user && <AccountIdentityHeader editable={path === '/account'} />}
          <motion.div key={pathname} initial={reducedMotion ? false : { opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: reducedMotion ? 0 : 0.18, ease: 'easeOut' }}>
          {loading ? <p role="status" data-testid="account-shell-loading">Loading account…</p> : <Outlet />}
          </motion.div>
        </div>
      </div>
    </main></div>
  </div>;
};